import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

// ===============================|| NEW VERSION DIALOG ||=============================== //

function NewVersionDialog(props) {
    const { onClose, open } = props;

    const handleClose = () => {
        onClose();
    };

    const reload = () => {
        window.location.reload();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ p: 3 }}
        >
            <DialogTitle id="alert-dialog-title">
                {' '}
                <FormattedMessage id="new-version" />
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">
                    <FormattedMessage id="click-reload" />
                </Typography>
            </DialogContent>
            <DialogActions sx={{ pr: 2.5 }}>
                <Button onClick={handleClose} color="error">
                    <FormattedMessage id="disagree" />
                </Button>
                <Button variant="contained" size="small" onClick={reload} autoFocus>
                    <FormattedMessage id="reload" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

NewVersionDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

export default NewVersionDialog;
